import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

class carousel {
  constructor() {
    const init = () => {
      const swiper = new Swiper('.site-hero-banner .swiper', {
        modules: [Navigation],
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          slideChange: function() {
            var activeSlide = this.slides[this.activeIndex];
            var slideText = activeSlide.getAttribute('data-slide-text');
            var titleContainer = document.getElementById('hero-banner-title');

            if (slideText && slideText.trim() !== '') {
              titleContainer.innerHTML = slideText;
            } else {
              titleContainer.innerHTML = '<h1 class="mb-2">BusConnects Dublin</h1><span><i class="fa-solid fa-location-dot"></i> Liffey Valley to City Centre</span>';
            }
          }
        },
      });
    };

    // Check if the DOM is loaded; if not, wait for it
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
}

export default carousel;
